import {HTMLProps, ReactNode} from 'react';
import Text from './Text';

interface IProps
  extends Omit<HTMLProps<HTMLElement>, 'as' | 'height' | 'children'> {
  line: number;
  width?: string;
  height?: string;
  children: ReactNode;
}

// webkit 브라우저에서만 제대로 동작한다.(firefox에서는 줄 바꿈이 된다)
export default function EllipsisText({
  className,
  line,
  width = '100%',
  style,
  children,
  ...rest
}: IProps) {
  return (
    <Text
      className={cn('overflow-hidden text-ellipsis', className)}
      style={{
        width,
        ...style,
        WebkitLineClamp: line,
        WebkitBoxOrient: 'vertical',
        display: '-webkit-box',
      }}
      {...rest}
    >
      {children}
    </Text>
  );
}
